import RangeToStepsConverterBase from './RangeToStepsConverterBase.js';

class SymmetricRangeToStepsConverter extends RangeToStepsConverterBase{
    constructor(negativeRangeStepsConverter, positiveRangeStepsConverter){
        super();

        if (!(negativeRangeStepsConverter instanceof RangeToStepsConverterBase)){
            throw new TypeError('negativeRangeStepsConverter must be an instance inheriting from RangeToStepsConverterBase class');
        }

        if (!(positiveRangeStepsConverter instanceof RangeToStepsConverterBase)){
            throw new TypeError('positiveRangeStepsConverter must be an instance inheriting from RangeToStepsConverterBase class');
        }

        this.negativeRangeStepsConverter = negativeRangeStepsConverter;
        this.positiveRangeStepsConverter = positiveRangeStepsConverter;
    }

    getSteps(min, max){
        let steps = [];
        if (min < 0){
            steps = steps.concat(this.negativeRangeStepsConverter.getSteps(min, 0 - Number.EPSILON));
        }

        if (max >= 0){
            steps = steps.concat(this.positiveRangeStepsConverter.getSteps(0, max));
        }

        return steps;
    }
}

export default SymmetricRangeToStepsConverter;